type NonEmptyArray<T> = [T, ...T[]];
interface IndexTableHeading {
  title: string;
}

export const actionsTableHeadings: NonEmptyArray<IndexTableHeading> = [
  { title: "Status" },
  { title: "Name" },
  { title: "Hide Products" },
  { title: "Push Down Products" },
  { title: "Made Visible Products" },
  { title: "Push Back Up Products" },
  { title: "Total" },
  { title: "" }
];